const messages = {
    dashboard: {
        title: "Händler-Dashboard",
        extraTitle: "HÄNDLER-DASHBOARD",
        description:
            "Willkommen in Ihrem Dashboard. Hier können Sie die Zahlen und teilnehmenden Unternehmen aus Ihrem Kundenstamm einsehen.",
        overview: {
            title: "Übersicht der teilnehmenden Kunden",
            description:
                "Unternehmen, die sich bei BRIDGESTONE PLUS registriert haben und die wir über deren Kundennummer Ihrem Unternehmen zuordnen können.",
            month: "Neu in diesem Monat",
            year: "Neu in diesem Jahr",
            all: "Gesamt",
        },
        credits: {
            title: "Punktguthaben {name}",
            description:
                "Belohnungspunkte, die teilnehmenden Unternehmen basierend auf den von Ihnen hochgeladenen Verkaufszahlen zugewiesen werden. In dieser Ansicht werden die regulären Punkte ohne Promotionen angezeigt.",
            month: "Letzter Monat",
            year: "Aktuelles Jahr",
            prev_year: "Gesamt",
            allDealers: "Alle Punkte der Händler",
        },
        details: {
            title: "Details der teilnehmenden Kunden",
            description:
                'Unten finden Sie die Unternehmen, die sich bei BRIDGESTONE <span class="text-danger">PLUS</span> mit einer Kundennummer {name} registriert haben und Ihnen als Verantwortlichem zugeordnet wurden. Verwenden Sie die Sortierfunktionen, um die Reihenfolge zu ändern, oder nutzen Sie die Suchfunktion.',
        },
        lastImport:
            'Letzter Import der Verkaufszahlen: <br/> <span class="text-danger">{date}</span>',
        loadMore: "20 weitere Händler laden",
        tyres: {
            title: "Reifen",
            description: "Von Programmteilnehmern gekaufte Reifen",
        },
    },
};

export default {
    messages,
};
